module.exports = __webpack_public_path__ + "static/kartchen-info-allgemein2-f6b3a4f1cae49dbd3f35c63a88d7afab.png";